import { render, staticRenderFns } from "./v_Admin.vue?vue&type=template&id=77d7c477&scoped=true&"
import script from "./v_Admin.vue?vue&type=script&lang=js&"
export * from "./v_Admin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d7c477",
  null
  
)

export default component.exports